export default __webpack_public_path__ + "static/media/Kaan-Mac.87629694.webp";